module.exports = __webpack_public_path__ + "static/img/on.57c907b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/cursor/on.png
// module id = tAiQ
// module chunks = 0